import React, { MouseEventHandler, ReactNode } from "react"

import { Color, Size } from "~tailwindui/types/enums"

import { buttonClassNames } from "~tailwindui/helpers/classNameHelpers"

import classNames from "src/classNames"

import Spinner from "./Spinner"

export type ButtonProps = {
  children?: ReactNode
  text?: string | ReactNode
  size?: Size
  color?: Color
  className?: string
  outline?: boolean
  soft?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  type?: "button" | "submit" | "reset"
  loading?: boolean
}

const Button: React.FC<
  ButtonProps & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "size">
> = ({
  children,
  text,
  size = Size.Medium,
  color = Color.Blue,
  className = "",
  outline = false,
  soft = false,
  loading = false,
  disabled = false,
  ...props
}) => {
  return (
    <button
      disabled={disabled}
      type={props.type ?? "button"}
      className={classNames(
        buttonClassNames({
          size,
          color,
          outline,
          soft,
          disabled,
        }),
        className
      )}
      {...props}
    >
      <span className="flex items-center justify-center gap-3">
        {children || text}
        {loading && (
          <span className="inline-block">
            <Spinner className="!fill-white" />
          </span>
        )}
      </span>
    </button>
  )
}

export default Button
